const de = {
  demo: {
    title: `Germany`,
  },
  Home: `Heim`,
  Dashboard: `Armaturenbrett`,
  description: `beschreibung`,
  Description: `Beschreibung`,
  Details: `Einzelheiten`,
  Book: `Buch`,
  Books: `Bücher`,
  Invoices: `Rechnungen`,
  Theme: `Thema`,
  Settings: `Einstellungen`,
  "Theme Settings": `Thema Einstellungen`,////////
  Pages: `Seiten`,
  Product: `Produkt`,
  Contacts: `Kontakte`,
  "Account Settings": `Konto Einstellungen`,
  Notifications: `Benachrichtigungen`,
  More: `Mehr`,
  Profile: `Profil`,
  Logout: `Ausloggen`,
  "Add To Cart": `In den Warenkorb legen"`,
  "Buy Now": `Kaufe jetzt`,
  "Save Changes": `Änderungen speichern`,
  "Create Success!": `Erfolgreich erstellen!`,
  "Update Success!": `Erfolgreich aktualisiert!`,
  "Book Name": `Buchname`,
  "New Book": `Neues Buch`,
  "Create Book": `Buch erstellen`,
  "Create a new book": `Erstellen Sie ein neues Buch`,
  "Edit Book": `Buch bearbeiten`,
  "Regular Price": `Regulärer Preis`,
  "Are you sure want to delete?": `Möchten Sie wirklich löschen?`,
  "Book Details": `Buchdetails`,
  "Item for Approval": `Artikel zur Genehmigung`,
  "Are you sure want to approve this item?": `Möchten Sie diesen Artikel wirklich genehmigen?`,
  "No Data": `Keine Daten`,
  "First Name": `Vorname`,
  "Last Name": `Nachname`,
  "Email Address": `E-Mail-Addresse`,
  "Phone Number": `Telefonnummer`,
  "Please Select Country Code": `Bitte wählen Sie die Ländervorwahl`,
  "State/Region": `Bundesland/Region`,
  "Zip/Code": `Postleitzahl`,
  "Please Select a Role": `Bitte wählen Sie eine Rolle`,
  "User: List | Minimal UI": `Benutzer: Liste | Minimal UI`,
  "User List": `Benutzerliste`,
  "New User": `Neuer Benutzer`,
  Email: `Email`,
  Gender: `Geschlecht`,
  Country: `Land`,
  State: `Zustand`,
  City: `Stadt`,
  Role: `Rolle`,
  Company: `Unternehmen`,
  Address: `Adresse`,
  Verified: `Verifiziert`,
  Images: `Bilder`,
  Save: `Sparen`,
  Cancel: `Stornieren`,
  Quantity: `Menge`,
  Color: `Farbe`,
  Size: `Größe`,
  Name: `Name`,
  Status: `Status`,
  Price: `Preis`,
  "Created At": `Hergestellt in`,
  "Are you sure want to delete": `Möchten Sie wirklich löschen`,
  delete_confirmation: `Sind Sie sicher, dass Sie das Element {{value1}} löschen möchten?`,
  approve_success: `Ihr {{value1}}-Buch ist genehmigt`,
  app: `app`,
  User: `Benutzer`,
  Users: `Benutzer`,
  items: `Artikel`,
  list: `liste`,
  Add: `Hinzufügen`,
  Edit: `Bearbeiten`,
  Delete: `Löschen`,
  Share: `Teilen`,
  Notification: `Benachrichtigung`,
  Sort: `Sortieren`,
  Search: `Suche`,
  Filter: `Filter`,
  Approved: `Genehmigt`,
  Approve: `Genehmigen`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  Management: `management`,
  Title: `Titel`,
  Date: `Datum`,
  Time: `Zeit`,
  "Detail user": `Detailbenutzer`,
  "Edit user": `Benutzer bearbeiten`,
  "Create a new user": `Erstellen Sie einen neuen Benutzer`,
  "Create User": `Benutzer erstellen`,
  "Approve this User?": `Diesen Benutzer genehmigen?`,
  "Enabling this will now allow user to login.": `Wenn Sie dies aktivieren, kann der Benutzer sich jetzt anmelden.`,
  "Activate this account?": `Dieses Konto aktivieren?`,
  "Disabling this will deactivate users account.": `Wenn Sie dies deaktivieren, wird das Benutzerkonto deaktiviert.`,
  "First Name is required": `Vorname ist erforderlich`,
  "Email is required": `Email ist erforderlich`,
  "Email must be a valid email address": `E-Mail muss eine gültige E-Mail-Adresse sein`,
  "Phone number is required": `Telefonnummer ist erforderlich`,
  "Role is required": `Rolle ist erforderlich`,
  "Name is required": `Name ist erforderlich`,
  "Price should not be $0.00": `Der Preis sollte nicht $0.00 sein`,
  "Description is required": `Beschreibung ist erforderlich`,
};

export default de;
